import React from 'react'
import styles from './CheckBoxLine.module.scss'
import { IconCheckboxMinus, IconCheckboxPlus } from 'assets'
import { IconButton } from 'components/common'
import { CheckBox, CheckBoxStatus } from './CheckBox'
import { FilterTypes } from 'models'

const CheckBoxLine = props => {
  const {
    store, object, subObjectLevel, expandable, expanded,
    onClick, selectedObjects, setFilterProp, childPropertyName, filterType
  } = props

  const isThisAProjectsFilter = filterType.toLowerCase() === FilterTypes.PROJECTS.toLowerCase()
  const isThisAProductsFilter = filterType.toLowerCase() === FilterTypes.PRODUCTS.toLowerCase()

  const handleOnSelect = () => {
    expandable
      ? onClick()
      : handleOnCheckBoxClick()
  }

  const isObjectSelected = (id = object.id) => {
    return !!selectedObjects.find(obj => obj.id === id)
  }

  const isObjectPartiallySelected = (obj = object) => {
    const children = obj[childPropertyName]
    if (!children || !children.length) return false

    let result = false
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < children.length; i++) {
      if (isObjectSelected(children[i].id) || isObjectPartiallySelected(children[i])) {
        result = true
        break
      }
    }

    return result
  }

  const areAllChildrenSelected = () => {
    const children = object[childPropertyName]
    if (!children || !children.length) return false

    let result = true
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < children.length; i++) {
      if (!isObjectSelected(children[i].id)) {
        result = false
        break
      }
    }

    return result
  }

  const handleOnCheckBoxClick = () => {
    let newSelectedObjects = [...selectedObjects]

    const excludeObject = objectId => {
      newSelectedObjects = newSelectedObjects.filter(obj => obj.id !== objectId)
    }

    const excludeSelfAndChildren = objectId => {
      if (isObjectSelected(objectId)) {
        const selectedObject = newSelectedObjects.find(obj => obj.id === objectId) || {}
        // const index = newSelectedObjects.findIndex(obj => obj.id === objectId);
        const children = selectedObject[childPropertyName] || []
        // newSelectedObjects.splice(index, 1);
        excludeObject(objectId)
        children.forEach(child => excludeSelfAndChildren(child.id))
      }
    }

    const excludeParents = objectId => {
      const idsToExclude = []

      const getParentId = objId => {
        return (newSelectedObjects.find(obj => obj.id === objId) || {}).parentId || 'all'
      }

      let parentId = getParentId(objectId)
      while (parentId !== 'all') {
        idsToExclude.push(parentId)
        parentId = getParentId(parentId)
      }
      idsToExclude.push(parentId)

      idsToExclude.forEach(id => excludeObject(id))
    }

    const pushSelfAndChildren = parentObj => {
      if (!isObjectSelected(parentObj.id)) {
        newSelectedObjects.push(parentObj)
        const children = parentObj[childPropertyName] || []
        children.forEach(child => pushSelfAndChildren(child))
      }
    }

    if (isObjectSelected(object.id)) {
      if (isThisAProjectsFilter) {
        excludeParents(object.id)
        excludeSelfAndChildren(object.id)
      } else {
        excludeObject(object.id)
      }
    } else {
      if (isThisAProjectsFilter) {
        pushSelfAndChildren(object)
      } else {
        newSelectedObjects.push(object)
      }
    }

    const filterPropertyKey = isThisAProductsFilter
      ? 'products'
      : store
    setFilterProp({ [filterPropertyKey]: newSelectedObjects })
  }

  const getCheckBoxStatus = () => {
    return isObjectSelected()
      ? CheckBoxStatus.CHECKED
      : !isThisAProjectsFilter
        ? CheckBoxStatus.UNCHECKED
        : areAllChildrenSelected()
          ? CheckBoxStatus.ALL_CHILDREN_ARE_CHECKED
          : isObjectPartiallySelected()
            ? CheckBoxStatus.PARTIALLY_CHECKED
            : CheckBoxStatus.UNCHECKED
  }

  const additionalPadding = expandable ? 0 : 16

  const isObjectSelectable = () => {
    // if (object.id === 'all') return true;
    if (expandable && !isThisAProjectsFilter) return false
    return true
  }

  return (
    <div
      className={styles.container}
      style={{
        paddingLeft: subObjectLevel * 10 + additionalPadding
      }}
    >
      {expandable &&
        <IconButton
          icon={expanded ? IconCheckboxMinus : IconCheckboxPlus}
          className={styles.icon}
          onClick={onClick}
        />
      }
      {isObjectSelectable()
        ? (
          <CheckBox
            className={styles.checkBox}
            onClick={handleOnCheckBoxClick}
            status={getCheckBoxStatus()}
          />
        )
        : <div style={{ width: 16, height: 19 }} />
      }
      <span onClick={handleOnSelect}>{object.name}</span>
    </div>
  )
}

export default CheckBoxLine
